import { isEmptyObject } from '../../../utils/tests';
import { MatchCardQuery, MatchCardSubscription } from '../types';

/**
 * typeguard for MatchChangeHpQuery
 * @param MatchChangeHpQuery object passed to transformer
 */
export const isValidMatchCard = (obj: MatchCardQuery) => Boolean(obj?.data?.getMatchCard && !isEmptyObject(obj.data.getMatchCard));

/**
 * typeguard for MatchChangeHpSubscription
 * @param MatchChangeHpSubscription object passed to transformer
 */
export const isValidMatchCardSubscription = (obj: MatchCardSubscription) => Boolean(obj?.data?.onUpdateMatchCardByMatchId && !isEmptyObject(obj.data.onUpdateMatchCardByMatchId));